import React from 'react';
import { FooterPanel } from './FooterPanel';
import { LocalizedLink } from 'src/components/common/LocalizedLink';

interface MenuBarProps {
  children: React.ReactNode;
  leftText: string;
  rightText?: string;
  leftLink: string;
  rightLink?: string;
  isFooterVisible?: boolean;
  rightLinkIsExternal?: boolean;
}

export const MenuBar: React.FC<MenuBarProps> = ({
  children,
  leftText,
  rightText,
  leftLink,
  rightLink,
  isFooterVisible = false,
  rightLinkIsExternal = false, // デフォルトは false
}) => {
  let showFooterMenu = true;
  if (typeof window !== 'undefined') {
    const currentURL = window.location.href;
    if (
      currentURL.includes('magazine') ||
      currentURL.includes('neighberhood')
    ) {
      showFooterMenu = false;
    }
  }

  return (
    <div className="relative z-0">
      {/* メインコンテンツ */}
      <div className="pb-20 bg-whiteYellow">{children}</div>

      {isFooterVisible && (
        <div className="fixed bottom-[calc(4rem+20px)] w-full z-50">
          <FooterPanel isVisible={isFooterVisible} />
        </div>
      )}

      {/* フッターメニュー - 条件付きレンダリング */}
      {showFooterMenu && (
        <div className="bg-whiteYellow border-t border-b border-black max-md:py-4 fixed bottom-0 w-full z-40">
          {/* SP用デザイン */}
          <div className="flex justify-between items-center px-4 md:hidden">
            {/* 左側のリンク (内部リンクは LocalizedLink を利用) */}
            <LocalizedLink
              to={leftLink}
              className="text-black underline text-sm"
            >
              {leftText}
            </LocalizedLink>

            {/* 右側: rightLinkが存在する場合はリンク、存在しない場合は空要素 */}
            {rightLink ? (
              rightLink.startsWith('#') ? (
                <a href={rightLink} className="text-black underline text-sm">
                  {rightText}
                </a>
              ) : rightLinkIsExternal ? (
                <a
                  href={rightLink}
                  className="text-black underline text-sm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {rightText}
                </a>
              ) : (
                <LocalizedLink
                  to={rightLink}
                  className="text-black underline text-sm"
                >
                  {rightText}
                </LocalizedLink>
              )
            ) : (
              <span className="text-sm text-black" />
            )}
          </div>

          {/* PC用デザイン */}
          <div className="hidden md:relative md:h-16 md:flex">
            {/* 左側のリンク */}
            <div className="flex items-center justify-center w-1/2">
              <LocalizedLink to={leftLink} className="text-black underline">
                {leftText}
              </LocalizedLink>
            </div>
            {/* 右側 */}
            <div className="flex items-center justify-center w-1/2">
              {rightLink ? (
                rightLink.startsWith('#') ? (
                  <a href={rightLink} className="text-black underline">
                    {rightText}
                  </a>
                ) : rightLinkIsExternal ? (
                  <a
                    href={rightLink}
                    className="text-black underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {rightText}
                  </a>
                ) : (
                  <LocalizedLink
                    to={rightLink}
                    className="text-black underline"
                  >
                    {rightText}
                  </LocalizedLink>
                )
              ) : (
                <span className="text-black" />
              )}
            </div>
            {/* 中央の線を絶対配置で中央に固定 */}
            <div className="absolute top-0 bottom-0 left-1/2 transform -translate-x-1/2">
              <div className="h-full w-px bg-black"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuBar;
